import { render, staticRenderFns } from "./CallCenterAdd.vue?vue&type=template&id=3a187b52&scoped=true"
import script from "./CallCenterAdd.vue?vue&type=script&lang=js"
export * from "./CallCenterAdd.vue?vue&type=script&lang=js"
import style0 from "./CallCenterAdd.vue?vue&type=style&index=0&id=3a187b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a187b52",
  null
  
)

export default component.exports